import { Component, Input } from '@angular/core';
import { UsedBy, CalcConfigService } from '_services/calc-config.service';
import { filter } from 'lodash-es';
import { NgStyle, AsyncPipe } from '@angular/common';

const USAGE_DISPLAY: Record<UsedBy['useType'], { color: string; icon: string }> = {
  Package: { color: '#00599d', icon: './assets/images/icons8-open_box.svg' },
  Cost: { color: '#512DA8', icon: './assets/images/icons8-money.svg' },
  Table: { color: '#006617', icon: './assets/images/icons8-data_sheet_filled.svg' },
  Formula: { color: '#BF360C', icon: './assets/images/icons8-math.svg' },
  Population: { color: '#C2185B', icon: './assets/images/icons8-groups.svg' },
  'Next Step': { color: '#5D4037', icon: './assets/images/icons8-web_design.svg' },
};

@Component({
    selector: 'app-usage',
    templateUrl: './usage.component.html',
    styleUrls: ['./usage.component.scss'],
    imports: [NgStyle, AsyncPipe]
})
export class UsageComponent {
  @Input({ required: true }) entityType!: 'Population' | 'Table' | 'Formula' | 'Question';
  @Input({ required: true }) entityId!: string;

  constructor(
    public cc: CalcConfigService
  ) { }

  filteredList(usedBy: UsedBy[]): UsedBy[] {
    return filter(usedBy, { 'entityId': this.entityId, 'entityType': this.entityType });
  }

  getColor(item: UsedBy): string {
    return USAGE_DISPLAY[item.useType].color;
  }

  getIcon(item: UsedBy): string {
    return USAGE_DISPLAY[item.useType].icon;
  }

}
